import { render, staticRenderFns } from "./QuizCompletionStatusBadge.vue?vue&type=template&id=4f2047b0&scoped=true"
import script from "./QuizCompletionStatusBadge.vue?vue&type=script&lang=js"
export * from "./QuizCompletionStatusBadge.vue?vue&type=script&lang=js"
import style0 from "./QuizCompletionStatusBadge.vue?vue&type=style&index=0&id=4f2047b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f2047b0",
  null
  
)

export default component.exports